/** Product-wide hard limits. MB uses decimal bytes (200,000,000 bytes). */
export const MAX_VIDEO_UPLOAD_BYTES = 200_000_000;
export const MAX_VIDEO_DURATION_MS = 15 * 60 * 1000;
export const VIDEO_UPLOAD_LIMIT_TEXT = 'Up to 200 MB · 15 minutes maximum';
export function videoUploadLimitError(sizeBytes, durationMs) {
    if (!Number.isFinite(sizeBytes) || sizeBytes <= 0)
        return 'The video file is empty or invalid.';
    if (sizeBytes > MAX_VIDEO_UPLOAD_BYTES)
        return 'Video must be 200 MB or smaller.';
    if (durationMs !== undefined) {
        if (!Number.isFinite(durationMs) || durationMs <= 0)
            return 'Could not read the video duration. Choose a valid video file.';
        if (durationMs > MAX_VIDEO_DURATION_MS)
            return 'Video must be 15 minutes or shorter.';
    }
    return null;
}
//# sourceMappingURL=upload-limits.js.map